import { reviews, siteInfo } from "@/mocks/site";

export default function PrincipleSection() {
  return (
    <section className="bg-foreground-950 text-background-100" aria-labelledby="principle-title">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-14 md:px-8 md:py-20">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-14">
          <div className="lg:col-span-5">
            <span className="inline-flex items-center gap-2 rounded-full bg-background-800 px-3 py-1 text-xs font-medium text-accent-300">
              <i className="ri-shield-check-line" />
              内容原则
            </span>
            <h2
              id="principle-title"
              className="mt-5 font-heading text-2xl font-bold leading-snug text-background-50 md:text-3xl"
            >
              围观可以很快，但不能失真
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-background-300">
              {siteInfo.intro}
            </p>

            <div className="mt-8 flex flex-wrap gap-6 border-t border-background-800 pt-6">
              {reviews.map((review) => (
                <figure key={review.name} className="w-full rounded-lg bg-background-900 p-4 sm:w-[calc(50%-12px)] lg:w-full">
                  <div className="flex items-center gap-1 text-accent-400">
                    {[0, 1, 2, 3, 4].map((star) => (
                      <i key={star} className="ri-star-fill text-xs" />
                    ))}
                  </div>
                  <blockquote className="mt-3 text-sm leading-relaxed text-background-200">
                    “{review.text}”
                  </blockquote>
                  <figcaption className="mt-3 text-xs text-background-400">
                    {review.name} · {review.role}
                  </figcaption>
                </figure>
              ))}
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:gap-5">
              {siteInfo.principles.map((item) => (
                <div key={item.title} className="rounded-lg border border-background-800 bg-background-900/60 p-5">
                  <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                    <i className={`${item.icon} text-xl`} />
                  </span>
                  <h3 className="mt-4 font-heading text-base font-semibold text-background-50">{item.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-background-300">{item.text}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}